import React from 'react';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
import Footer from '../components/resuableComponents/Footer';
import { Container, Divider, Grid } from '@mui/material';
import { useEffect } from 'react';

const step = [
	'-> API Integration can be ready-made or customized totally depends upon Travel Agency requirements and Budget. If Travel Agency has a small budget to start an online booking system on their brand name then they can go with a white label solution.',
	'-> High Profitability and Global reach helps to increase the revenue of your Travel Agency.',
	'-> It provides more flexibility to make changes in your portal. Additional features also to be given to the consumers according to their choices.',
	'-> Fast and Error free online booking facility helps to gain good feedback and reviews.',
	'-> Personalised service attracts the user as the portal becomes very user friendly.',
	'-> Live Tracking, Social Media Integration helps in marketing of your business.',
	'-> Customization and Editing Facility boost your business in every aspect.',
	'-> Online payment through Payment Gateways API Integration.',
	'-> Not waiting for confirmation.',
	'-> 24/7 technical support gives your business more flexibilities.',
	'-> Less running and maintenance cost compare to offline system.',
	'-> SMS and E-Mail API Integration for Booking related notifications.',
	'-> Global supplier API integration provide vast inventory to your users.',
	'-> Fully automation from supplier to user makes your business less complex.',
	'-> Instant Booking Confirmation makes your portal more reliable and flexible for users.',
	'-> Easy Management helps you in doing stress free business and run your business with joy.',
	'-> Integrated Payment Gateway makes portal more flexible by giving multiple payment modes.',
	'-> This also helps in your brand promotion. By providing the best inventory at a reasonable price to your customer you can build customer faith and high satisfaction.',
];

const step2 = [
	'Page Management',
	'Blog management',
	'Website Management',
	'SEO Friendly',
	'Visitor Tracking',
	'Live Chat Integration',
	'Own Branding',
	'Payment Gateway Integration',
	'Email Integration',
	'SMS Integration',
	'Social Media Integration',
	'Customer dashboard',
	'Centralised Mid office',
];
const step3 = [
	'Markup management',
	'Offer Management',
	'Discount Management',
	'Convenience Fee Management',
	'Coupon Management',
	'Staff Management',
	'Advance reports',
	'Unlimited Bandwidth',
	'SSL Secure website',
	'Customer Feedback',
	'E Ticket',
	'large service network',
	'24*7 technical support',
];
const AndroidEcom = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	return (
		<div>
			<Navbar />

			<div
				style={{
					backgroundImage:
						"url('https://aryaaviation.com/assets/images/ecommerce-module-android-mobile-app.jpg')",
					height: '25vh',
					fontSize: '50px',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
				}}>
				<h1 style={{ textAlign: 'center', color: 'white', padding: 10 }}>
					E-COMMERCE ANDROID APP DEVELOPMENT
				</h1>
				<h6 style={{ textAlign: 'center', fontSize: 20, color: 'white' }}>
					E-COMMERCE ANDROID APP DEVELOPMENT
				</h6>
			</div>

			<div style={{ padding: 10 }}>
				<h1 style={{ textAlign: 'center', fontSize: 30, marginTop: 20 }}>
					E-COMMERCE ANDROID APP DEVELOPMENT
				</h1>
				<Divider />
				<Container style={{ marginTop: 20 }}>
					<Grid container spacing={4}>
						<Grid item xs={4}>
							<img src='https://aryaaviation.com/assets/images/ecommerce_iosapplication.jpg' />
						</Grid>
						<Grid item xs={8}>
							<p>
								In today's digital era we can not say no to E-Commerce industry
								digitalization. Nowadays every buyer wants to search and order
								his goods and items as per his/her preference. After checking
								all available options buyers always choose and order products
								which is more profitable and also have faster delivery option.
								Arranging all the process of delivering goods to consumer by
								E-Commerce agencies is a very big challenge. To overcome all
								these difficulties E-Commerce Mobile Application is the best
								solution. In this Information Technology era, you can access the
								complete wide range of items through a pocket-sized device.
								E-Commerce app development is a one-stop solution for E-Commerce
								Companies and Buyers to order their items and goods.
							</p>
							<br />
							<p>
								The tools that we use for android application development
								projects are of very high standard. Our experienced team of 5
								years is more than capable of designing any app you imagine into
								a fully functional android application. Android applications
								that we develop are made using JAVA programming language along
								with the Android SDK. We have worked with 600+ customers
								worldwide including the start-ups, SMEs, Fortune 400 and Global
								800+ companies.
							</p>

							<br />
						</Grid>
					</Grid>
				</Container>

				<Divider />
			</div>

			<Footer />
		</div>
	);
};

export default AndroidEcom;
